export default __webpack_public_path__ + "static/media/message-icon.96cb186d.svg";